var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Restauration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 24 6 C 14.972684 6 7.4880476 12.703287 6.2128906 21.384766 L 4.4140625 19.585938 A 2.0002 2.0002 0 0 0 2.9785156 18.980469 A 2.0002 2.0002 0 0 0 1.5859375 22.414062 L 6.5859375 27.414062 A 2.0002 2.0002 0 0 0 9.4140625 27.414062 L 14.414062 22.414062 A 2.0002 2.0002 0 1 0 11.585938 19.585938 L 10.380859 20.791016 C 11.826078 14.594436 17.350706 10 24 10 C 31.756241 10 38 16.243759 38 24 C 38 31.756241 31.756241 38 24 38 C 19.173607 38 14.942675 35.571971 12.421875 31.873047 A 2.0002 2.0002 0 1 0 9.1171875 34.126953 C 12.356387 38.880029 17.828393 42 24 42 C 33.917759 42 42 33.917759 42 24 C 42 14.082241 33.917759 6 24 6 z M 24 19 C 21.243 19 19 21.243 19 24 C 19 26.757 21.243 29 24 29 C 26.757 29 29 26.757 29 24 C 29 21.243 26.757 19 24 19 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Restauration);
export default __webpack_public_path__ + "static/media/icons8-restauration.8d8ae3131d7bc561c8282a85114a4608.svg";
export { ForwardRef as ReactComponent };